module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "offset-sm2": "",
      "mt-4": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "blue accent-2"
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('message.list.selectmonth'),
      "no-data-text": _vm.$t('message.nodata'),
      "items": _vm.availableFilters,
      "dark": "",
      "prepend-icon": "date_range"
    },
    on: {
      "change": _vm.changeFilter
    },
    model: {
      value: (_vm.settings.currentFilter),
      callback: function($$v) {
        _vm.settings.currentFilter = $$v
      },
      expression: "settings.currentFilter"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "green",
    attrs: {
      "fab": "",
      "small": "",
      "top": "",
      "right": "",
      "absolute": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.createItem($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.workdayItems), function(item) {
    return [_c('v-list-tile', {
      key: item.id,
      attrs: {
        "avatar": "",
        "to": {
          name: 'View',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-chip', {
      staticClass: "green white--text"
    }, [_vm._v(_vm._s(_vm._f("moment")(item.start, "DD")))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', [_vm._v(_vm._s(_vm._f("moment")(item.start, "HH:mm a")) + " - " + _vm._s(_vm._f("moment")(item.end, "HH:mm a")))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', [_vm._v(" (" + _vm._s(item.lapse) + ")")]), _vm._v("\n                  " + _vm._s(_vm.$n(item.income, 'currency')) + "\n               ")])], 1)], 1)]
  })], 2), _vm._v(" "), _c('v-card-actions', {
    staticClass: "blue accent-2 white--text"
  }, [_c('v-spacer'), _vm._v(" "), _c('span', {
    staticClass: "white--text text-xs-right body-2"
  }, [_vm._v("\n           " + _vm._s(_vm.$t('message.total')) + ": " + _vm._s(_vm.$n(_vm.totalIncome, 'currency')) + "            \n         ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69ac4cdd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = 236
// module chunks = 1